// extracted by mini-css-extract-plugin
module.exports = {"navTab":"navTab_navTab__2vwpU","navTabMobile":"navTab_navTabMobile__1mCl_"};